export enum SurveyListFilterNames {
	clientId = 'clientId',
	startDate = 'startDate',
	endDate = 'endDate',
	query = 'query',
}

export interface ISurveyListFilter {
	[SurveyListFilterNames.clientId]?: string;
	[SurveyListFilterNames.startDate]?: string;
	[SurveyListFilterNames.endDate]?: string;
	[SurveyListFilterNames.query]?: string;
}
